import React from 'react';
import {
  Typography, Checkbox, Switch,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { productIcons } from '../../data/Constants';
import { resourceFormStyle } from '../../css/style';
import ToolTip from './ToolTip';
import { isDeviceView } from '../../utils/Functions';

const styles = resourceFormStyle();
const IosSwitch = withStyles(styles.iosSwitchStyles)(Switch);

const ProductIcon = (props) => {
  const {
    fieldTitle, iconSwitch, onSwitchChange, onCheckBoxChange, iconCheckBox, resources, field, disabled, hideSwitch, width,
  } = props;

  const checkBoxes = (fieldTitle === 'Legend') ? productIcons : [];
  const iconSmallContainer = (isDeviceView('sm', width) && (fieldTitle === 'Show Note' || fieldTitle === 'Disabled')) ? 'iconSmallContainerColumnView' : 'iconSmallContainer';

  return (
    <div>
      <div style={styles[iconSmallContainer]}>
        <div style={styles.itemTitleContainer}>
          <Typography style={styles.itemTitle}>{fieldTitle}</Typography>
          <ToolTip resources={resources} field={field} />
        </div>
        {
          !hideSwitch
          && (
            <div style={styles.switchAndText}>
              <div>
                <IosSwitch
                  checked={iconSwitch}
                  onChange={() => onSwitchChange()}
                  disableRipple
                  disabled={disabled}
                />
              </div>
              <div style={styles.yesOrNoText}>
                {iconSwitch ? 'Yes' : 'No'}
              </div>
            </div>
          )
        }
      </div>
      <div style={styles.legendCheckboxContainer}>
        {
          fieldTitle === 'Legend'
          && (
            checkBoxes.map((item, index) => (
              <div key={item.key} style={styles.checkBoxAndLabel}>
                <Checkbox
                  checked={Boolean(iconCheckBox[index])}
                  style={styles.iconCheckBox}
                  onChange={() => onCheckBoxChange(item, index)}
                />
                <Typography style={{ fontFamily: 'Lato' }}>{item.title}</Typography>
              </div>
            ))
          )
        }
      </div>
    </div>
  );
};

ProductIcon.propTypes = {
  iconSwitch: PropTypes.bool,
  onSwitchChange: PropTypes.func,
  onCheckBoxChange: PropTypes.func,
  iconCheckBox: PropTypes.array,
  resources: PropTypes.objectOf(PropTypes.any).isRequired,
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  disabled: PropTypes.bool,
};

export default ProductIcon;
